import Pusher from "pusher-js";

export const pusher = new Pusher('053b46ade17800ff6525', {
  cluster: 'eu'
});
